const CASE_UUID_IN_LINK_RE =
  /\/case-detail\/([0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12})/i;

/** Résout un UUID de cas depuis caseId, metadata ou le lien /case-detail/{uuid}. */
export function resolveNotificationCaseId({ caseId = null, metadata = {}, link = null } = {}) {
  const fromMeta = metadata?.caseId || metadata?.case_id || null;
  if (caseId) return String(caseId);
  if (fromMeta) return String(fromMeta);
  const match = typeof link === 'string' ? link.match(CASE_UUID_IN_LINK_RE) : null;
  return match?.[1] || null;
}
